import Button from '@ui/button/Button';
import analytics from '@utils/analytics';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ProductNotifyMeModal from './ProductNotifyMeModal';
const ProductActionNotifyMe = (props) => {
    var _a;
    const { t } = useTranslation();
    const [showOverlay, setShowOverlay] = React.useState(false);
    const btnModifiers = useMemo(() => {
        if (props.noModifiers) {
            return [];
        }
        let btnClass = props.secondary ? 'button--secondary' : 'button--primary';
        if (props.inverted) {
            btnClass += '-inverted';
        }
        return [btnClass];
    }, [props.secondary, props.inverted, props.noModifiers]);
    const onOpenModal = () => {
        setShowOverlay(true);
        props.onOpenModal && props.onOpenModal();
        analytics.notifyMe(props.product.masterId, props.from);
    };
    const onCloseModal = (triggerCloseOnly) => {
        setShowOverlay(false);
        typeof triggerCloseOnly != 'boolean' && props.onCloseModal && props.onCloseModal();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "button", cls: (_a = props.customClasses) !== null && _a !== void 0 ? _a : btnModifiers, onClick: () => {
                onOpenModal();
            }, ariaHaspopup: "dialog", tabIndex: props.tabIndex },
            React.createElement("span", { className: "btn-label" },
                props.icon && React.createElement("i", { className: `icon--${props.icon}` }),
                t('label.notifyme'))),
        !props.inQuickShop && (React.createElement(ProductNotifyMeModal, { isOpen: showOverlay, title: t('label.notifyme'), product: props.product, color: props.color, size: props.size, onRequestClose: onCloseModal, from: props.from, fromReserve: props.fromReserve }))));
};
export default ProductActionNotifyMe;
